import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { DateTime } from "luxon";
import { Link } from "react-router-dom";

import Localization from "../../../localization";
import Button from "../../../components/button";
import Image from "../../../components/image";
import AnimateHeight from "react-animate-height";
import { fixExternalLinks, getUrl } from "../../../utils/helper";

class Lesson extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
        };
    }

    _toggleVisible = () => {
        this.setState({
            visible: !this.state.visible,
        });
    };

    _renderLevel(level) {
        const { locale } = this.props;

        return (
            <div className="relative flex justify-end items-center group pb-15">
                <p className="font-bold">
                    {Localization[locale].classes.level + ": "}
                </p>
                <img src="/img/paw_filled.png" className="h-12 mx-4" />
                <img
                    src={level > 1 ? "/img/paw_filled.png" : "/img/paw.png"}
                    className="h-12 mr-4"
                />
                <img
                    src={level > 2 ? "/img/paw_filled.png" : "/img/paw.png"}
                    className="h-12"
                />
                <div className="pointer-events-none absolute -bottom-10 right-0 transition-opacity opacity-0 group-hover:opacity-100">
                    <p className="inline-block border border-blue rounded-full px-4">
                        {Localization[locale].classes["level_" + level]}
                    </p>
                </div>
            </div>
        );
    }

    render() {
        const { lesson, locale, last } = this.props;
        const { visible } = this.state;

        let lessonDate = DateTime.fromISO(lesson.date);
        let isOver =
            lessonDate.set({ hour: 9, minute: 30 }).diffNow("seconds").seconds <
            0;

        let height = 0;
        if (visible) {
            height = "auto";
        }

        return (
            <div className={`mt-16 ${!last && "border-b border-blue"} pb-16`}>
                <div className="flex">
                    <div className="w-100">
                        {lesson.cover && (
                            <Image
                                alt={lesson.cover.alt || lesson.name}
                                url={lesson.cover.url}
                                aspectRatio="aspect-ratio-square"
                                width={100}
                            />
                        )}
                    </div>
                    <div className="px-20 flex-1 flex flex-col justify-between space-y-20">
                        <div>
                            <p className="font-bold">{lesson.teacher_name}</p>
                            <p className="font-bold">{lesson.name}</p>
                            <p className="font-bold">{lesson.time}</p>
                            {lesson.events && lesson.events.length > 0 && (
                                <div className="mt-2 space-y-2 flex flex-col items-start">
                                    {lesson.events.map((event) => (
                                        <Link
                                            to={getUrl("events/" + event.slug)}
                                            type="button"
                                            className="inline-block border border-blue rounded-full px-4 transition-colors hover:bg-blue hover:text-pink"
                                        >
                                            {event.name}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </div>
                        <Link
                            to={getUrl("lessons/" + lesson.slug)}
                            type="button"
                            className={`${
                                !visible
                                    ? "opacity-100 pointer-events-auto"
                                    : "opacity-0 pointer-events-none"
                            } transition-opacity text-left underline`}
                        >
                            {Localization[locale].classes.see_details}
                        </Link>
                    </div>
                    <div className="text-right flex flex-col justify-between space-y-20">
                        <div>
                            {lesson.space_id && !lesson.is_online && (
                                <p className="font-bold">
                                    {Localization[locale].classes.local +
                                        ": " +
                                        lesson.space.name}
                                </p>
                            )}
                            {lesson.is_online && (
                                <p className="font-bold">
                                    {Localization[locale].classes.online}
                                </p>
                            )}
                            <p className="font-bold">
                                {Localization[locale].classes.price + ": "}
                                {lesson.price === 0
                                    ? Localization[locale].classes.free
                                    : lesson.price + " €"}
                            </p>
                            {lesson.level && this._renderLevel(lesson.level)}
                        </div>
                        {!isOver && lesson.tickets_url && (
                            <div className="flex justify-end">
                                <Button
                                    href={lesson.tickets_url}
                                    text={
                                        lesson.price > 0
                                            ? Localization[locale].classes.buy
                                            : Localization[locale].classes
                                                  .reserve
                                    }
                                    backgroundColor={"bg-blue"}
                                    backgroundColorOver={"bg-blue"}
                                    borderColor={"border-blue"}
                                    textStyle={
                                        "font-judge z-10 transition text-pink"
                                    }
                                    wrapperStyle="px-15"
                                />
                            </div>
                        )}
                    </div>
                </div>
                <AnimateHeight id={lesson.id} duration={300} height={height}>
                    <div className="pl-120">
                        <div
                            className="article-body"
                            dangerouslySetInnerHTML={{
                                __html: fixExternalLinks(lesson.description),
                            }}
                        />
                    </div>
                    <div className="pl-120 mt-30">
                        <div
                            className="article-body"
                            dangerouslySetInnerHTML={{
                                __html: fixExternalLinks(lesson.biography),
                            }}
                        />
                    </div>
                    <div
                        className={`${
                            visible ? "opacity-100" : "opacity-0"
                        } transition-opacity pl-120 mt-30`}
                    >
                        <button
                            onClick={this._toggleVisible}
                            type="button"
                            className="text-left underline"
                        >
                            {Localization[locale].classes.close_details}
                        </button>
                    </div>
                </AnimateHeight>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Lesson);
